import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import ProductrawFilterCriteria from './ProductrawFilterCriteria'
import ProductrawListImpl from './ProductrawListImpl'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './ProductrawAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setProductrawDashboardProductrawList } from '../../store/slice/PharmaSlice';

export default function ProductrawListView({setShowEdit,setProductrawId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.productrawDashboard);   

    const [filteredProductrawList, setFilteredProductrawList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { productrawDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (productrawDashboard.productrawList.length>-1){
        setFilteredProductrawList(productrawDashboard.productrawList);
        transformToCardFormat(productrawDashboard.productrawList, setCardList);
      }
    },[productrawDashboard.productrawList])

    useEffect(()=>{
          transformToCardFormat(filteredProductrawList, setCardList);
      },[filteredProductrawList])

    useEffect(()=>{
        if (filterCriteria.productid==='' && filterCriteria.productname==='' && filterCriteria.rmid==='' && filterCriteria.rmname==='' && filterCriteria.qty==='' && filterCriteria.unitid==='' && filterCriteria.unitname==='' && filterCriteria.status==='' ){
            setFilteredProductrawList(productrawDashboard.productrawList);
            transformToCardFormat(productrawDashboard.productrawList, setCardList);

        } else {
            setFilteredProductrawList(
                productrawDashboard.productrawList
                    .filter(productraw=> productraw.rmname.toString().toUpperCase().includes(filterCriteria.rmname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(productrawDashboard.filteredProductrawList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <ProductrawListImpl
                    setShowEdit={setShowEdit}
                    setProductrawId = {setProductrawId}
                    tableList={filteredProductrawList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}